<template>
    <mt-popup v-model="popupVisible" position="center">

        <div class="popbox">
            <span>{{ $t("图形验证码") }}</span>
            <img :src="verifyinfo.image" class="imgstyle" @click="run()">
            <input type="text" :placeholder="$t('请输入验证码')" class="numinput" v-model.trim="imgnum">
            <div class="footer"><button class="btn1" @click.stop="cancel">{{ $t("取消") }}</button> <button class="btn2"
                    @click.stop="confirm">{{ $t("确定") }}</button>
            </div>
        </div>
    </mt-popup>
</template>
<script>

import { httpGetImageVerify } from "@/api"   //图形验证
import { httpGetCode } from "@/api/userCenter"   //获取二维码
import { mapState } from "vuex"
import { Toast } from "mint-ui";
export default {
    props: {
        scene: {
            type: String,
            required: true,
        },
        username: {
            type: String,
        }
    },
    emit: ['imageCallback'],
    data() {

        return {
            popupVisible: false,
            verifyinfo: {},
            imgnum: ''

        }
    },
    computed: {
        ...mapState({
            userInfo: (state) => state.userInfo,
        }),
    },
    watch: {
        popupVisible(val) {
            if (val) {

                this.imgnum = ''
                // this.verifyinfo = {}
            }


        }

    },
    methods: {
        run() {
            httpGetImageVerify({
                username: this.username ? this.username : this.userInfo.mobile || this.userInfo.user_email,
                scene: this.scene
            }).then(({ data }) => {
                this.verifyinfo = data
                this.popupVisible = true
                //如果有值不用验证
                if (data.captcha) {

                    // 执行回调
                    this.$emit('imageCallback', { captcha_id: data.captcha_id, captcha: imgnum })
                }

            }).catch(() => { })
        },
        confirm() {
            if (!this.imgnum) {
                return false
            } else {

                // 执行发送验证码
                // this.$emit('imageCallback', { captcha_id: this.verifyinfo.captcha_id, captcha: this.imgnum })
                this.dosend()
            }

        },
        cancel() {

            this.popupVisible = false
        },

        dosend() {

            httpGetCode({
                username: this.username ? this.username : this.userInfo.mobile || this.userInfo.user_email,
                scene: this.scene,
                captcha_id: this.verifyinfo.captcha_id,
                captcha: this.imgnum
            })
                .then((res) => {
                    // 发送成功
                    this.popupVisible = false
                    // console.log(res.msg);
                    this.$emit('imageCallback',)
                    // this.Toast(res.msg);
                    Toast(res.msg);
                    // this.$refs.code.run();
                    // this.$refs.imageverify.cancel()

                })
                .catch((res) => {

                    if (res == '20002') {
                        this.run()
                    } else if (res == '0') {

                        this.cancel()
                    }
                });

        }


    }
}
</script>
<style scoped>
.popbox {

    width: 90vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;

}

.imgstyle {


    margin: 20px 0;
}

.footer {

    display: flex;
    align-items: center;
    width: 100%;
    border-top: 1px solid #c0c0c0;
    margin-top: 20px;
}

.btn1 {
    flex: 1;
    text-align: center;
    padding: 10px 0;
    background-color: transparent;
}

.btn2 {

    flex: 1;
    text-align: center;
    padding: 10px 0;
    color: #1e87d9;
    background-color: transparent;
    border-left: 1px solid #c0c0c0;
}

.numinput {
    width: 250px;
    padding: 10px 0;
    text-align: center;
    background-color: #f2f8f4;
    border-radius: 5px;
}

.numinput::-webkit-input-placeholder {
    text-align: center;
}

.numinput::-ms-input-placeholder {
    text-align: center;
}
</style>